import React, { useState } from 'react';
import { creatorAPI } from '../../../api';

// Quick Capture — the heart of the dashboard. ONE field, zero decisions.
export default function QuickCapture({ t, onCaptured }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const capture = async () => {
    const v = text.trim();
    if (!v || busy) return;
    setBusy(true);
    try {
      await creatorAPI.capture(v);
      setText('');
      onCaptured?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="crs-capture" data-testid="creator-quick-capture">
      <p className="crs-capture__label">{t.cr_whats_on_mind || 'What\u2019s on your mind?'}</p>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); capture(); } }}
        placeholder={t.cr_capture_placeholder || 'Capture your thought, idea or reminder\u2026'}
        rows={3}
        data-testid="creator-capture-input"
      />
      <div className="crs-capture__foot">
        <p className="crs-capture__hint">{t.cr_capture_hint || 'It goes to Brain Dump. You can organize it later.'}</p>
        <button type="button" onClick={capture} disabled={busy || !text.trim()} data-testid="creator-capture-btn">
          {busy ? '\u2026' : (t.cr_capture_btn || 'Capture')}
        </button>
      </div>
    </div>
  );
}
